import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { CategorySection } from '../components/CategorySection';
import { FeaturedProducts } from '../components/FeaturedProducts';
import { MetalPriceUpdates } from '../components/MetalPriceUpdates';
import { LatestInsights } from '../components/LatestInsights';
export const Home: React.FC = () => {
  return <div className="min-h-screen bg-white dark:bg-gray-900 w-full" data-id="element-1272">
      <HeroSection data-id="element-1273" />
      <CategorySection data-id="element-1274" />
      <FeaturedProducts data-id="element-1275" />
      <MetalPriceUpdates data-id="element-1276" />
      <LatestInsights data-id="element-1277" />
    </div>;
};